import { render } from "./post-item-hub.vue?vue&type=template&id=7245a5e6"
import script from "./post-item-hub.vue?vue&type=script&lang=js"
export * from "./post-item-hub.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__